import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table } from "antd";
import { AgentList } from "../../Redux/Actions/agentActions";
import { columnsAgents } from "../../Global Functions/columnsAntd";
import ListTopSearch from "../../Global Functions/listTopSearch";
import DateRangePopup from "../../Utils/dateFilterPopup";
import ProfileStatusDropdown from "./profileStatusDropdown";
import toast from "react-hot-toast";

const ListAgent = () => {
  const dispatch = useDispatch();

  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState(searchQuery);
  const [isDatePopupVisible, setIsDatePopupVisible] = useState(false);
  const [dateRange, setDateRange] = useState({ start: null, end: null });
  const [profileStatus, setProfileStatus] = useState("");

  const { agents, loading } = useSelector((state) => state.agents);

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: ["5", "10", "20", "50", "100"],
  });

  const handleStatusChange = async (record, action) => {
    let payload = { id: record._id };
    if (action === "block") payload.status = "BLOCK";
    else if (action === "unblock") payload.status = "UNBLOCK";
    else payload.status = action;
    fetchDetails(pagination.current, pagination.pageSize);
  };

  const fetchDetails = useCallback(async (page, pageSize, showLoader = true) => {
    const teamData = {
      page,
      limit: pageSize,
      is_deleted: false,
      role: ["exclusive partner"],
      filter: debouncedSearch,
      ...(dateRange.start && { start_date: dateRange.start.format("YYYY-MM-DD") }),
      ...(dateRange.end && { end_date: dateRange.end.format("YYYY-MM-DD") }),
      ...(profileStatus && { profile_status: profileStatus }),
    };

    try {
      await dispatch(AgentList(teamData, showLoader));
      if (!showLoader) toast.success("Agent list refreshed");
    } catch {
      if (showLoader) toast.error("Failed to fetch agent list");
    }
  }, [dispatch, debouncedSearch, dateRange, profileStatus]);

  useEffect(() => {
    fetchDetails(pagination.current, pagination.pageSize);
  }, [pagination.current, pagination.pageSize, fetchDetails]);

  useEffect(() => {
    if (agents?.total) {
      setPagination((prev) => ({ ...prev, total: agents.total }));
    }
  }, [agents]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 500);
    return () => clearTimeout(handler);
  }, [searchQuery]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const handleDateRangeApply = (start, end) => {
    if (start === null && end === null) {
      setDateRange({ start: null, end: null });
    } else {
      setDateRange({ start, end });
    }
    setIsDatePopupVisible(false);
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  return (
    <>
      <div className="bookings_table">
        <div className="table_component_all">
          <div style={{ gridColumn: "span 5", height: "auto" }}>
            <ListTopSearch
              h3heading="Agent List"
              setState={setSearchQuery}
              onCalendarClick={() => setIsDatePopupVisible(true)}
            />
          </div>

          <div
            style={{
              position: "static",
              marginTop: "-72px",
              marginLeft: "83%",
              marginBottom: "24px",
            }}
          >
            <ProfileStatusDropdown
              value={profileStatus}
              onChange={(e) => setProfileStatus(e.target.value)}
            />
          </div>

          <div className="custom_table">
            <div style={{ padding: "0px 60px" }}>
              <Table
                dataSource={(Array.isArray(agents?.data) && agents.data) || []}
                columns={columnsAgents(handleStatusChange)}
                pagination={pagination}
                loading={loading}
                onChange={handleTableChange}
                scroll={{ x: 1700, y: 500 }}
                rowClassName={() => "text-center"}
              />
            </div>
          </div>
        </div>
      </div>

      <DateRangePopup
        visible={isDatePopupVisible}
        initialStart={dateRange.start}
        initialEnd={dateRange.end}
        onCancel={() => setIsDatePopupVisible(false)}
        onOk={handleDateRangeApply}
      />
    </>
  );
};

export default ListAgent;